import React, { useState } from 'react';
import ProgramList from './ProgramList';
import EnrolledUsersList from '../EnrolledUsers/EnrolledUsersList';

const ProgramManagement = () => {
  // When set, we are drilled into a single program's enrolled-users view.
  // Clicking a row in ProgramList sets this; the Back button on
  // EnrolledUsersList clears it.
  const [selectedProgram, setSelectedProgram] = useState<any | null>(null);

  if (selectedProgram) {
    return (
      <div className="program-management-container h-full">
        <EnrolledUsersList
          program={selectedProgram}
          onBack={() => setSelectedProgram(null)}
        />
      </div>
    );
  }

  return (
    <div className="program-management-container h-full">
      <ProgramList onProgramClick={setSelectedProgram} />
    </div>
  );
};

export default ProgramManagement;
